import {useQuery} from '@apollo/react-hooks';

import type {FilterObject} from 'nutshell-core/types';

import type {
    GetProspectorContacts as GetProspectorContactsQuery,
    GetProspectorContacts_prospectorContacts_mcfxContacts as GetProspectorContacts,
    GetProspectorContactsVariables as GetProspectorContactsQueryVariables,
} from 'nutshell-graphql-types';

import {pruneMustHaveFilters, convertFilterArrayToProspectorFiltersForApi} from '../../helpers';

import GET_PROSPECTOR_CONTACTS from '../queries/get-prospector-contacts.graphql';

export function useGetProspectorContacts(
    filters: FilterObject[],
    skip: number
): {
    prospectorContacts: GetProspectorContacts[];
    totalCount: number;
    nextSkip: number;
    isLoading: boolean;
    refetch: any;
} {
    const propertyBasedFilters = pruneMustHaveFilters(filters);
    const {data, loading, refetch} = useQuery<
        GetProspectorContactsQuery,
        GetProspectorContactsQueryVariables
    >(GET_PROSPECTOR_CONTACTS, {
        fetchPolicy: 'cache-and-network',
        variables: {
            input: convertFilterArrayToProspectorFiltersForApi(filters),
            skip: skip,
        },
        skip: !propertyBasedFilters.length,
    });

    const prospectorContacts = data ? data.prospectorContacts : null;

    return {
        prospectorContacts: (prospectorContacts && prospectorContacts.mcfxContacts) || [],
        totalCount: (prospectorContacts && prospectorContacts.totalCount) || 0,
        nextSkip: (prospectorContacts && prospectorContacts.nextSkip) || 0,
        isLoading: loading,
        refetch,
    };
}
